// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 3496 ? "graphql-print" : chunkId) + "." + {"3496":"7ef39872c8b54dd4","4871":"d569cb6fb466b296","6291":"8b77e2da2a18e6f6"}[chunkId] + ".js";
};